import { ArticleResolution } from '@wix/answers-api';
import {
  Box,
  CustomModalLayout,
  Loader,
  Text,
  Button,
  ModalMobileLayout,
} from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FunctionComponent, useContext } from 'react';
import { Context } from '../../../context';
import { DATA_HOOKS } from '../../../dataHooks';
import { isMobile } from '../../../utils/userAgent';
import css from './index.module.scss';

export type RoadmapFeatureRequestSuccessModalProps = {
  onClose: () => void;
  isLoading: boolean;
  resolution?: ArticleResolution;
};
export const RoadmapFeatureRequestSuccessModal: FunctionComponent<
  RoadmapFeatureRequestSuccessModalProps
> = ({ onClose, isLoading, resolution }) => {
  const { t } = useTranslation();
  const context = useContext(Context);
  const isMobileView = isMobile(context);

  const successModal = (
    <Box
      padding={isMobileView ? '' : '100px 0'}
      direction="vertical"
      align="center"
      verticalAlign="middle"
    >
      <Box
        direction="vertical"
        align="center"
        verticalAlign="middle"
        padding={isMobileView ? '16px' : 'SP4'}
      >
        <Text
          className={css.successModalTitle}
          dataHook={DATA_HOOKS.ROADMAP_FEATURE_REQUEST_SUCCESS_MODAL_TITLE}
          textAlign="center"
          size="medium"
          weight="bold"
        >
          {resolution
            ? resolution === ArticleResolution.COLLECTING_VOTES
              ? t('feature-request.modal.success.title.vote')
              : t('feature-request.modal.success.title.follow')
            : t('feature-request.modal.success.title')}
        </Text>
        <Text
          className={css.successModalSubtitle}
          dataHook={DATA_HOOKS.ROADMAP_FEATURE_REQUEST_SUCCESS_MODAL_SUBTITLE}
          textAlign="center"
          size="medium"
        >
          {resolution
            ? t('feature-request.modal.success.sub-title.vote')
            : t('feature-request.modal.success.sub-title')}
        </Text>
      </Box>
      {!resolution && (
        <Text
          textAlign="center"
          dataHook={
            DATA_HOOKS.ROADMAP_FEATURE_REQUEST_SUCCESS_MODAL_DESCRIPTION
          }
          className={css.successModalDescription}
          size="medium"
        >
          {t('feature-request.modal.success.description')}
        </Text>
      )}
      <Button
        dataHook={DATA_HOOKS.ROADMAP_FEATURE_REQUEST_SUCCESS_MODAL_CLOSE_BUTTON}
        onClick={onClose}
        size="small"
      >
        {t('feature-request.modal.success.close-button')}
      </Button>
    </Box>
  );

  const loader = (
    <Box align="center" verticalAlign="middle" width={'100%'} height={'500px'}>
      <Loader size={isMobileView ? 'medium' : 'large'} />
    </Box>
  );

  return isMobileView ? (
    <ModalMobileLayout
      content={isLoading ? loader : successModal}
      onCloseButtonClick={onClose}
      className={css.mobileSuccessModal}
    />
  ) : (
    <CustomModalLayout
      className={css.featureRequestSuccessModal}
      onCloseButtonClick={onClose}
      content={isLoading ? loader : successModal}
      width={'600px'}
    />
  );
};
